import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  variant?: 'blue' | 'orange';
  right?: React.ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  variant = 'blue',
  right,
}: PageHeaderProps) {
  const gradient =
    variant === 'orange' ? 'bg-gradient-bonus' : 'bg-gradient-header';

  return (
    <div className={`${gradient} w-full`}>
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-6 md:py-10 flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h1 className="text-[22px] md:text-[28px] font-black text-white leading-tight font-nunito">
            {title}
          </h1>
          {subtitle && (
            <p className="text-[13px] font-semibold text-white/65 mt-1 font-nunito">
              {subtitle}
            </p>
          )}
        </div>
        {right && (
          <div className="flex-shrink-0">{right}</div>
        )}
      </div>
    </div>
  );
}
